import {
  LineOfCreditSoftCreditCheckUnion,
  Mutation,
} from '@varo/graphql-schema-types';
import LineOfCreditSoftCreditCheck from 'services/graphql/mutations/LineOfCreditSoftCreditCheck';
import { CombinedError, useMutation } from 'urql';

interface LineOfCreditSoftCreditCheckResult {
  result?: LineOfCreditSoftCreditCheckUnion;
  error?: CombinedError;
  fetching: boolean;
  triggerMutation: (idempotencyId: string) => void;
}

const useLineOfCreditSoftCreditCheck =
  (): LineOfCreditSoftCreditCheckResult => {
    const [{ data, fetching, error }, executeMutation] = useMutation<Mutation>(
      LineOfCreditSoftCreditCheck,
    );

    const triggerMutation = (idempotencyId: string) => {
      void executeMutation({
        idempotencyId,
      });
    };

    return {
      result: data?.lineOfCreditSoftCreditCheck,
      fetching,
      error,
      triggerMutation,
    };
  };

export default useLineOfCreditSoftCreditCheck;
